import {
  Checkbox as RawCheckbox,
  CheckboxProps as RawCheckboxProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import { useController } from 'react-hook-form';

export interface CheckboxInputProps extends RawCheckboxProps {
  type: 'checkbox';
  name: string;
}

export default function CheckboxInput(props: CheckboxInputProps) {
  const { onChange, disabled, readOnly, name, type, error, ...rest } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  return (
    <RawCheckbox
      {...rest}
      {...field}
      disabled={_disabled}
      error={_error}
      checked={field.value}
      onChange={(e) => {
        field.onChange(e.currentTarget.checked);
        onChange?.(e);
      }}
    />
  );
}
